// plate-builder.js — extracted from sections/plate-builder.liquid

document.addEventListener('DOMContentLoaded', function () {
  const regInput = document.getElementById('reg');
  const frontPlate = document.getElementById('frontPlate');
  const rearPlate = document.getElementById('rearPlate');
  const legalityStatus = document.getElementById('legalityStatus');
  const sizeLabel = document.getElementById('plateSizeLabel');
  const styleSelect = document.getElementById('style');
  const sizeSelect = document.getElementById('size');
  const placementSelect = document.getElementById('placement');
  const form = document.getElementById('plateForm');

  // Safety guard: if the builder isn't on this page, do nothing
  if (!regInput || !frontPlate || !rearPlate || !form) return;

  // Grab reg from URL if present
  const urlParams = new URLSearchParams(window.location.search);
  const regFromURL = urlParams.get('reg');
  if (regFromURL) regInput.value = decodeURIComponent(regFromURL).toUpperCase();

  function isRoadLegal(input) {
    const clean = input.toUpperCase().trim();
    const patterns = [
      /^[A-Z]{2}\d{2}\s[A-Z]{3}$/,      // AB12 CDE
      /^[A-Z]\d{1,3}\s[A-Z]{3}$/,       // A1 ABC, A123 ABC
      /^[A-Z]{3}\s\d{1,3}[A-Z]$/,       // ABC 1D, ABC 123D
      /^[A-Z]{1,3}\s\d{1,4}$/,          // ABC 1234
      /^[A-Z]{3}\s\d{3}$/               // ABC 123
    ];
    return patterns.some(p => p.test(clean));
  }

  const sizeLabels = {
    standard: "Standard UK Plate (520mm x 111mm)",
    "6digit": "6 Digit Plate (406mm x 111mm)",
    "5digit": "5 Digit Plate (350mm x 111mm)",
    range: "Oversized Range Rover (21\" x 6\") - REAR"
  };

  function updatePreview() {
    const text = regInput.value.toUpperCase() || "CUSTOM";
    frontPlate.textContent = text;
    rearPlate.textContent = text;

    const legal = isRoadLegal(text);

    if (!text.trim()) {
      legalityStatus.textContent = "";
      legalityStatus.className = "legality-status";
    } else if (legal) {
      legalityStatus.textContent = "Road Legal ✓";
      legalityStatus.className = "legality-status legal";
    } else {
      legalityStatus.textContent = "Show Plate ✕ (Not road legal spacing)";
      legalityStatus.className = "legality-status not-legal";
    }

    const placement = placementSelect.value;
    frontPlate.style.display = placement === "rear" ? "none" : "inline-flex";
    rearPlate.style.display = placement === "front" ? "none" : "inline-flex";

    const style = styleSelect.value;
    [frontPlate, rearPlate].forEach(el => {
      el.classList.remove("style-standard", "style-3d", "style-4d", "style-5d");
      el.classList.add(`style-${style}`);
    });

    const size = sizeSelect.value;
    [frontPlate, rearPlate].forEach(el => {
      el.classList.remove("size-standard", "size-6digit", "size-5digit", "size-range");
    });

    if (size === "range") {
      rearPlate.classList.add("size-range");
      frontPlate.classList.add("size-standard");
    } else {
      frontPlate.classList.add(`size-${size}`);
      rearPlate.classList.add(`size-${size}`);
    }

    sizeLabel.textContent = sizeLabels[size];
  }

  regInput.addEventListener("input", updatePreview);
  styleSelect.addEventListener("change", updatePreview);
  sizeSelect.addEventListener("change", updatePreview);
  placementSelect.addEventListener("change", updatePreview);

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const reg = encodeURIComponent(regInput.value.trim());
    const size = encodeURIComponent(sizeSelect.value);
    const type = encodeURIComponent(placementSelect.value);
    const style = styleSelect.value;
    const text = regInput.value.toUpperCase();
    const legal = isRoadLegal(text);

    let baseUrl = "";

    if (!legal) {
      baseUrl = "/products/show-plate";
    } else {
      if (style === "standard") baseUrl = "/products/standard-number-plate";
      if (style === "3d")       baseUrl = "/products/3d-gel-number-plate";
      if (style === "4d")       baseUrl = "/products/4d-3mm-number-plate";
      if (style === "5d")       baseUrl = "/products/5d-plates";
    }

    const finalUrl = `${baseUrl}?reg=${reg}&size=${size}&type=${type}&style=${style}`;
    window.location.href = finalUrl;
  });

  // Initial render
  updatePreview();
});
